import { Fragment, ReactElement, useRef, useEffect, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { IconButton, Badge } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { systemEventActions } from '../../redux/slices/system-event.slice';
import { RootState } from '../../redux/store';
import { SystemEventSocket } from '../../sockets/system-event.socket';
import { ESystemEventName } from '../../types/@system-event';
import { notificationActions } from '../../redux/slices/notification.slice';

const SystemEventBadge = (): ReactElement => {
  const authToken = useSelector((state: RootState) => state.auth.token);
  const dispatch = useDispatch();
  const [systemEventCount, setSystemEventCount] = useState<number>(0);
  const { current: socket } = useRef(new SystemEventSocket());

  useEffect(() => {
    if (!authToken) {
      setSystemEventCount(0);
      return;
    }

    socket.init(authToken);

    socket.addListener(ESystemEventName.systemEventInit, (data: number) => {
      setSystemEventCount(typeof data === 'number' ? data : 0);
    });

    socket.addListener(ESystemEventName.systemEventUpdate, (data: any) => {
      const nextCount =
        typeof data?.count === 'number' ? data.count : 0;

      setSystemEventCount(nextCount);

      const title = data?.data?.title || 'New notification';
      const message = data?.data?.message || '';

      dispatch(
        notificationActions.info({
          message: message ? `${title}: ${message}` : title,
        }),
      );
    });

    return () => {
      socket.disconnect();
    };
  }, [socket, authToken, dispatch]);

  const handleSystemEventCardOpen = () => {
    dispatch(systemEventActions.setSystemEventBadgeCardOpen(true));
    dispatch(systemEventActions.getAll({ page: 1 }));
    dispatch(systemEventActions.checkAll());
    setSystemEventCount(0);
  };

  return (
    <Fragment>
      <IconButton
        size="large"
        aria-label="system events"
        color="inherit"
        onClick={handleSystemEventCardOpen}
      >
        <Badge badgeContent={systemEventCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Fragment>
  );
};

export default SystemEventBadge;